module.exports = __webpack_public_path__ + "img/icon-youtube.aa7ca379.svg";